import moment from 'moment';
import globals from '../../../globals/communityGlobals';
import { lowerFirstLetter } from '../../../utils/helpers';

export const eventHandlers = (state, setState) => {
  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });

  const eventDescriptionLocale = globals.getArea('eventDescriptionTranslationKey');

  const handleSidePanel = (isOpen, selectedEntry) => {
    setState(newState => ({ ...newState, openSidePanel: isOpen, selectedEntry }));
  };

  const onClose = () => {
    setState(newState => ({ ...newState, openSidePanel: false }));
  };

  const onFiltersChange = model =>
    setState({
      ...state,
      selectedEventTypes: model.selectedEventTypes,
      filterDateFrom: model.filterDateFrom || null,
      filterDateTo: model.filterDateTo || null,
      pasKey: model.pasKey,
      currentPage: 1,
    });

  const generateDescription = (descriptionKey, parameters) => {
    return eventDescriptionLocale.getMsg(lowerFirstLetter(descriptionKey), parameters);
  };

  // const eventTypesBtn = [
  //   'ActivityAddedToTreatmentInstanceEvent',
  //   'AssignedTreatmentInstanceStartedEvent',
  //   'AssignedTreatmentInstanceFinishedEvent',
  //   'ReferralCreatedEvent',
  //   'ReferralUpdatedEvent',
  //   'ReferralClosedEvent',
  //   'TreatmentCreatedEvent',
  //   'TreatmentClosedEvent',
  //   'TreatmentInstanceAssignedToClinicianEvent',
  //   'TreatmentInstanceUnassignedFromClinicianEvent',
  //   'TreatmentInstanceCancelledEvent',
  //   'TreatmentInstanceDeletedEvent',
  //   'TreatmentInstanceRescheduledToClinicianEvent',
  //   'TreatmentInstanceRescheduledToDifferentDateEvent',
  //   'TreatmentPatternCreatedEvent',
  //   'TreatmentPatternModifiedEvent',
  //   'TreatmentVisitEditedEvent',
  //   'PatientAddedEvent',
  //   'PatientEditedEvent',
  //   'TreatmentDiscardEvent',
  // ];

  return {
    locale: globals.getAreas(['audit', 'error', 'selectableListsValues', 'userActions']),
    eventTypeLocale: globals.getArea('eventType'),
    dateFormats: globals.dateFormats.shortWithLongTime,
    moment,
    updateTableProps,
    updateTableSort,
    handleSidePanel,
    onClose,
    onFiltersChange,
    generateDescription,
  };
};
